<template>
  <div class="ssl">
    <TopHead name="预约游览" />
    <div class="ss_top">
      <!--banner轮播-->
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        lazy-render
      >
        <van-swipe-item
          v-for="(item,index) in bannerArr"
          :key="index"
          class="p_r"
          @click="bannerJump(item)"
        >
          <van-image
            fit="cover"
            :src="item.imgUrl"
          >
            <template #loading>
              <img
                src="../assets/img/img_loading.png"
                alt=""
              >
            </template>
          </van-image>
          <div class="p_a name">
            {{ item.name }}
          </div>
        </van-swipe-item>
      </van-swipe>

      <!--搜索框-->
      <search :is-show="false" />
    </div>

    <!--热门景区-->
    <div
      v-if="listTj.length"
      class="s_hot_ti"
    >
      热门景区
    </div>
    <div class="s_hot_out">
      <div
        v-for="(item,index) in listTj"
        :key="index"
        class="d_i s_item"
        @click="$router.push('/stDetail?id='+item.sellerId)"
      >
        <van-image
          fit="cover"
          :src="item.cover"
        >
          <template #loading>
            <img
              src="../assets/img/img_loading.png"
              alt=""
            >
          </template>
        </van-image>
        <div>
          <div class="si_ti text_over">
            {{ item.name }}
          </div>
          <div class="si_ti_sub text_over">
            <span v-for="(itm,idx) in item.tagList">{{ itm.name }} <span v-if="idx < item.tagList.length-1">| </span></span>
          </div>
          <div class="pri d_f ali_b text_over">
            ￥<span>{{ item.showPrice }}</span><span class="pri_sub">起</span>
          </div>
          <!--<div class="pri d_f ali_b text_over">{{item.showPrice}}</div>-->
        </div>
      </div>
    </div>

    <!--全部景区-->
    <div class="all_ss">
      <div class="as_ti">
        全部景区
      </div>
      <van-dropdown-menu
        active-color="#4C90F1"
        @change="changeType"
      >
        <van-dropdown-item
          v-model="params.data.sellerTypeCode"
          :options="option1"
          @change="changeType"
        />
        <van-dropdown-item
          v-model="params.data.ratingType"
          :options="option3"
          @change="changeType"
        />
      </van-dropdown-menu>

      <!--列表-->
      <van-pull-refresh
        v-model="loading"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            :key="index"
            class="list_item d_f ali_t"
            @click="$router.push('/stDetail?id='+item.sellerId)"
          >
            <van-image
              fit="cover"
              :src="item.cover"
            >
              <template #loading>
                <img
                  src="../assets/img/img_loading.png"
                  alt=""
                >
              </template>
            </van-image>
            <div class="flex_1 over_h">
              <div class="li_ti">
                {{ item.name }}
              </div>

              <div class="rate_out">

                <span>评分 </span>
                <template v-if="item.summarizenRating !== null">
                  <img
                    v-for="itm in Math.floor(item.summarizenRating)"
                    src="../assets/img/star_a.png"
                    alt=""
                  >
                  <img
                    v-if="Number(item.summarizenRating ? item.summarizenRating.toString().split('.')[1] : 0)>0"
                    src="../assets/img/star_half.png"
                    alt=""
                  >
                  <template v-else>
                    <img
                      v-if="item.summarizenRating<5"
                      src="../assets/img/star_dis.png"
                      class="hh"
                      alt=""
                    >
                  </template>
                  <template v-if="item.summarizenRating<5">
                    <img
                      v-for="itm in (4-Math.floor(item.summarizenRating))"
                      src="../assets/img/star_dis.png"
                      alt=""
                    >
                  </template>
                </template>
                <span>{{ item.summarizenRating  || '暂无评分'}}</span>
              </div>

              <div class="text_over">
                <span v-for="(itm,idx) in item.tagList">{{ itm.name }} <span v-if="idx < item.tagList.length-1">| </span></span>
              </div>
              <div class="">
                <span>{{ item.businessHours }}</span> | 距您
                <span v-if="item.distance<1000">距您{{Number(item.distance).toFixed(2)}}m</span>
                <span v-else>距您{{Number(item.distance/1000).toFixed(2)}}km</span>
              </div>
              <div class="pri">
                ￥<span>{{ item.showPrice }}</span><span class="pri_sub">起</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div id="container" />
  </div>
</template>

<script>
  export default {
    name: "ScenicSpotList",
    data() {
      return {
        rateNum:2.1,
        state:{
          value1: 0,
          value3: '3',
        },
        option1 : [],
        /*option2 : [
          { text: '门票价格', value: 'a' },
          { text: '好评排序', value: 'b' },
          { text: '销量排序', value: 'c' },
        ],*/
        option3 : [
          { text: '综合评分', value: '3' },
          { text: '服务评分', value: '1' },
          { text: '交通评分', value: '2' },
          { text: '环境评分', value: '4' },
          // { text: '口味评分', value: '5' },
        ],
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
          data:{
            ratingType:'3',
            sellerTypeCode:'',
          }
        },
        bannerArr:[],
        listTj:[],
      }
    },
    created(){
      this.getBanner();
      this.getSellerTypeList();
      this.getSellerTj();
    },
    methods: {
      bannerJump(row){
        if(row.interlinkage){
          if(row.backRequired){
            window.location.href = row.interlinkage;
          }else{
            this.$router.push(row.interlinkage)
          }
        }

      },

      listLoad(){
        let _t = this;
        this.loading = true;
        let longitude = this.$global.loactions[0];
        let latitude = this.$global.loactions[1];
        //景区和酒店
        if(longitude) this.params.data.longitude = longitude;
        if(latitude) this.params.data.latitude = latitude;
        this.$api.getSellerList(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let map = new AMap.Map("container", {
            resizeEnable: true,
            zoom: 13
          });

          map.plugin('AMap.Geolocation', function() {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000,
              // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
              buttonOffset: new AMap.Pixel(10, 20),
              //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
              zoomToAccuracy: true,
              //  定位按钮的排放位置,  RB表示右下
              buttonPosition: 'RB'
            })

            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', onComplete)
            AMap.event.addListener(geolocation, 'error', onError)

            function onComplete (data) {
              console.log(data)
              let myPos = new AMap.LngLat(data.position.lng, data.position.lat);//此处需要获取自己的定位来J进行算距离
              _t.list.map(item => {
                let listPop = new AMap.LngLat(item.longitude, item.latitude);
                let distance = Math.round(myPos.distance(listPop));
                if(distance<1000){
                  item.distance = distance+'m';
                }else{
                  item.distance = distance/1000+'km';
                }
              });
              let list = res.data.rows;
              if (!list || list.length < _t.params.pageSize) {
                _t.finished = true;
              }
            }
            function onError (data) {
              // alert('失败'+JSON.stringify(data))
              console.log(data)
            }
          })
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listLoad();
      },
      onLoad(){
        let me = this;
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listLoad();
      },
      //获取推荐列表
      getSellerTj(){
        let send = {
          pageIndex:1,
          pageSize:100,
          data:{
            sellerTypeCode:'seller_type_spot',
            isRecommend:1,
          }
        };
        this.$api.getSellerList(send).then(res => {
          this.listTj = res.data.rows;
        })
      },
      //改变下拉选项
      changeType(val){
        this.onRefresh();
      },
      //获取景区分类
      getSellerTypeList(){
        this.$api.getSellerTypeList({code:'seller_type_spot'}).then(res => {
          this.option1 = [];
          res.data.map(item => {
            this.option1.push({text:item.name,value:item.code})
          });
          this.params.data.sellerTypeCode = this.option1[0].value;
          this.listLoad();
        })
      },
      //banner跳转
      bannerGo(row){
        if(!row.interlinkage) return;
        this.$router.push(row.interlinkage)
      },
      //获取banner
      getBanner(){
        this.$api.getBanner({position:9}).then(res => {
          this.bannerArr = res.data;
        })
      },
    }
  }
</script>

<style scoped lang="scss">

  .list_item{
    .text_over{
      margin-bottom: 10px;
    }
    >.flex_1{
      padding-bottom: 15px;
      border-bottom: 1px solid #E0E0E0;
    }
    font-size: 22px;
    font-weight: 500;
    color: #6E6E6E;
    .rate_out{
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 500;
      color: #3E3E3E;
      .grade{
        color: #DB3D0C;
        margin-right: 40px;
      }
      img{
        width: 28px;
        margin-right:5px;
      }
      span{
        font-size: 24px;
        font-weight: 500;
        color: #3E3E3E;
        position: relative;
        top: -4px;
        margin-left: 3px;
      }
    }
    .li_ti{
      margin-bottom: 20px;
      font-size: 30px;
      font-weight: bold;
      color: #3E3E3E;
    }
    .van-image{
      width: 239px;
      height: 220px;
      border-radius: 10px;
      overflow: hidden;
      margin-right: 30px;
    }
    padding: 11px 15px 27px 0;
    background: #FFFFFF;
    border-radius: 5px;
  }
  .all_ss{
    .as_ti{
      /*margin-bottom: 30px;*/
      font-size: 38px;
      font-weight: bold;
      color: #3E3E3E;
    }
    background-color: white;
    padding: 38px 25px;
  }
  .pri{
    .pri_sub{
      font-size: 20px;
      font-weight: 400;
      color: #6E6E6E;
    }
    font-size: 30px;
    font-weight: bold;
    color: #D53C00;
  }
  .s_hot_out{
    .s_item{
      >div{
        .si_ti_sub{
          margin-bottom: 26px;
          font-size: 20px;
          font-weight: 500;
          color: #6E6E6E;
          height: 32px;
        }
        .si_ti{
          font-size: 26px;
          font-weight: bold;
          color: #3E3E3E;
          margin-bottom: 15px;
        }
        padding: 20px 20px 10px;
        background-color: white;
      }
      .van-image{
        padding: 0;
        height: 168px;
      }
      width: 260px;
      overflow: hidden;
      background: #FFFFFF;
      border-radius: 15px;
      margin-right: 14px;
    }
    padding: 0 0 25px 25px;
    white-space: nowrap;
    background-color: #f5f5f5;
    width: 100%;
    box-sizing: border-box;
    overflow-x: auto;
  }
  .s_hot_ti{
    font-size: 38px;
    font-weight: bold;
    color: #3E3E3E;
    padding: 30px 25px 32px;
    background-color: #f5f5f5;
  }
  .my-swipe{
    .van-swipe-item{
      .name{
        left: 0;
        bottom: 0;
        height: 46px;
        background: rgba(0, 0, 0, 0.45);
        padding: 0 25px;
        line-height: 46px;
        font-size: 26px;
        font-weight: 400;
        color: #FFFFFF;
        width: 100%;
        box-sizing: border-box;
      }
      height: 280px;
      border-radius: 10px;
      overflow: hidden;
    }
    margin-bottom: 35px;
  }
  .ss_top{
    padding: 25px;
    background-color: #f5f5f5;
  }
  .ssl{
    padding-top: 85px;
    height: 100vh;
    overflow: auto;
    box-sizing: border-box;
  }

</style>
